import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ModalComponent from '../../components/ModalComponent'

import amaka from '../../assets/amaka.png'
import peter from '../../assets/peter.png'
import sophia from '../../assets/sophia.png'
import noah from '../../assets/noah.png'

import facebook_square from '../../assets/facebook_square.png'
import instagram_square from '../../assets/instagram_square.png'

import user_img from '../../assets/user_img.png'
import ww from '../../assets/ww.png'
import project_detail from '../../assets/project_detail.png'

const ProfessionalDetail = () => {
	const [open, setOpen] = useState(false)
	const [openModal, setOpenModal] = useState(false)

	const projects = [amaka, peter, sophia, noah]

	const user_profile = {
		image: user_img,
		fullName: 'James Maduka',
		mobile: '08166245118',
		city: 'Lagos',
		country: 'Nigeria',
		created_at: '2021',
		description:
			"It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
		fb_link: 'https://facebook.com',
		ig_link: 'https://instagram.com',
		skills: ['Directing', 'Cinematography', 'Photographer'],
		languages: ['English', 'French', 'Igbo'],
	}

	const displayHandler = (e) => {
		e.preventDefault()
		setOpen(!open)
	}

	const toggleModal = () => {
		setOpenModal(!openModal)
	}

	return (
		<main className='prof_det_page'>
			<section style={{ background: `url(${ww})` }}>
				<div className='container'>
					<div className='row'>
						<div className='col-md-5 col-sm-12'>
							<div className='prof_det_page_box'>
								<div className='text-center'>
									<img src={user_profile.image} className='user_img' alt='' />
								</div>
								<h4> {user_profile.fullName} </h4>
								<a
									href='#'
									onClick={displayHandler}
									className={
										!open
											? 'form-control btn prof_det_page_box_btn'
											: 'form-control btn prof_det_page_box_btn1'
									}
								>
									{!open ? 'Contact me' : '0816 624 5118'}
								</a>

								<hr />

								<div className='d-flex justify-content-between'>
									<p>
										<img
											className='icon'
											src={require('../../assets/map_marker.png')}
											alt=''
										/>
										Location
									</p>
									<p>
										{user_profile.city}, {user_profile.country}.
									</p>
								</div>

								<div className='d-flex justify-content-between'>
									<p>
										<img
											className='icon'
											src={require('../../assets/user_icon.png')}
											alt=''
										/>
										Member since
									</p>
									<p> {user_profile.created_at}. </p>
								</div>

								<hr />

								<p>
									<strong>Description</strong>
								</p>
								<p> {user_profile.description} </p>

								<hr />

								<p>
									<strong>Languages</strong>
								</p>
								<p>
									{user_profile.languages.map((e) => (
										<span className='mr-1'> {e}. </span>
									))}
								</p>

								<hr />

								<p>
									<strong>Linked Account</strong>
								</p>

								<a href={`${user_profile.fb_link}`} className='social'>
									<img src={facebook_square} alt='' />
									Facebook
								</a>
								<a href={`${user_profile.ig_link}`} className='social'>
									<img src={instagram_square} alt='' />
									Instagram
								</a>

								<hr />

								<p>
									<strong>Skills</strong>
								</p>
								<p>
									{user_profile.skills.map((e) => (
										<span className='mr-1 skill'> {e} </span>
									))}
								</p>
							</div>
						</div>
						<div className='col-md-7 col-sm-12'>
							<h3 className='section_header pt-2'>Maduka's Projects</h3>
							<div className='row'>
								{projects.map((e) => (
									<div className='col-md-6 prof_det_page_proj'>
										<a
											href='#'
											onClick={(e) => {
												e.preventDefault()
												setOpenModal(true)
											}}
										>
											<img src={e} alt='' />
										</a>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</section>
			<ModalComponent
				open={openModal}
				toggle={toggleModal}
				size='lg'
				title='About Project'
			>
				<p style={{ fontSize: '14px' }}>
					It is a long established fact that a reader will be distracted by the
					readable content of a page when looking at its layout. The point of
					using Lorem Ipsum is that it has a more-or-less normal distribution of
					letters, as opposed to using 'Content here, content here', making it
					look like readable English.
				</p>

				<p>
					{' '}
					<strong>Link to project</strong>{' '}
				</p>
				<hr />
				<a href='#' target='_blank'>
					https//www.fullafricanvibes.com/blackproject/scopeone
				</a>
				<hr />
				<div className='mb-2 mt-2'>
					<img src={project_detail} className='img-fluid' alt='' />
				</div>
			</ModalComponent>
		</main>
	)
}

export default ProfessionalDetail
